import React from 'react'

import { formatNumber, NumberFormats } from '@/shared/tools/locale'

import { CircularGauge } from '../CircularGauge'

export function PercentageValueText({
	value = 0,
	percentage = 0,
	hidePercentage = false,
}: {
	hidePercentage?: boolean
	value?: number
	percentage?: number
}) {
	return (
		<>
			{!hidePercentage && (
				<CircularGauge data-icon='inline-start' percentage={percentage} />
			)}
			{formatNumber(value)} ({percentage < 1 && percentage !== 0 ? '<' : ''}
			{formatNumber(
				percentage !== 0 ? Math.max(percentage, 1) : 0,
				NumberFormats.Percent
			)}
			)
		</>
	)
}
